import React, { useState } from "react";
import OrderSummary from "../OrderSummary";
import WhiteTitledCard from "../../../../components/cards/WhiteTitledCard";
import { useAppSelector } from "../../../../redux/app/hooks";
import SearchInput from "../../../../components/form/SearchInput";
import DateRangeSelector, {
  DateRangeType,
} from "../../../ui/DateRangeSelector";
import { RootState } from "../../../../redux/app/store";
import Button from "../../../ui/Button";
import DisputeOrderTable from "./DisputeOrderTable";
import { canUseOrderManagementListFilters } from "../../../../helpers";

const DisputedOrders = () => {
  const [search, setSearch] = useState<string>("");
  const [inputValue, setInputValue] = useState<string>("");
  const { currentTable, disputeOrders } = useAppSelector(
    (state: RootState) => state.orders
  );
  const [selectedRange, setSelectedRange] = useState<DateRangeType>({
    startDate: null,
    endDate: null,
  });
  const { user } = useAppSelector((state) => state.auth);

  const handleDateChange = (range: DateRangeType) => {
    setSelectedRange(range);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      setSearch(inputValue);
    }
  };

  const tabList = [
    {
      id: 1,
      name: "Disputed Orders",
      count: disputeOrders?.pagination?.total ?? 0,
    },
  ];

  return (
    <div className=" flex flex-col gap-6 p-4 sm:p-6 md:p-8 bg-gray-100 min-h-screen">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold mb-4">Order Management</h1>
      </div>
      <OrderSummary />
      <WhiteTitledCard>
        <div className="px-6">
          <div className="flex flex-col-reverse sm:flex-row flex-wrap items-stretch sm:items-center gap-3 w-full">
            {canUseOrderManagementListFilters(user) && (
              <DateRangeSelector
                initialRange={selectedRange}
                onChange={handleDateChange}
              />
            )}
            <div className="items-center gap-4 flex">
              <SearchInput
                placeholder="Search"
                onChange={(e: any) => setInputValue(e.target.value)}
                value={inputValue}
                onKeyDown={handleKeyDown}
              />
              <Button
                layout="toolbar" size="sm"
                label="filter"
                onClick={() => setSearch(inputValue)}
                classNames="hidden sm:flex"
              />
            </div>
          </div>
          <div className="flex space-x-4 items-center">
            {tabList?.map((tab) => (
              <div
                key={tab.id}
                className={`space-x-2 cursor-pointer text-sm font-semibold p-2 ${
                  currentTable === tab.id
                    ? "text-black border-b-2 border-primary"
                    : ""
                }`}
                onClick={() => {
                  setSearch("");
                  setSelectedRange({
                    startDate: null,
                    endDate: null,
                  });
                }}
              >
                <span>{tab.name}</span>
                {
                  <span
                    className={"bg-lightPurple px-2  text-accent rounded-md"}
                  >
                    {tab?.count}
                  </span>
                }
              </div>
            ))}
          </div>
        </div>
        <DisputeOrderTable
          search={search}
          startDate={selectedRange?.startDate}
          endDate={selectedRange?.endDate}
        />
      </WhiteTitledCard>
    </div>
  );
};

export default DisputedOrders;
